import React, { useState, useEffect } from 'react';
import './i18n';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Desktop from './pages/Desktop';
import Admin from './pages/Admin';
import DesktopPage from './pages/DesktopPage';
import DatabaseConfigPage from './pages/DatabaseConfigPage';
import AppGroupApplicationsPage from './pages/AppGroupApplicationsPage';
import BackupSettingsPage from './pages/BackupSettingsPage';
import { PuttyPage } from './apps/puttyApp';
import ComposeWindowApp from './apps/ComposeWindowApp';
import AssociationSettingsPage from './pages/AssociationSettingsPage';
import StoreAppsPage from './pages/StoreAppsPage';
import { LocalSettingsProvider } from './contexts/LocalSettingsContext';

import api from './services/api';

import AuthPingWatcher from './AuthPingWatcher';
import { NotificationCenterProvider } from './components/NotificationCenter';

function App() {
  // Vérifie le token au chargement initial
  const storedToken = window.localStorage.getItem('token');
  const [token, setToken] = useState(storedToken);

  // Met à jour le token lors du login
  const handleLogin = (data) => {
    if (data && data.token) {
      setToken(data.token);
      window.localStorage.setItem('token', data.token);
    } else if (data && data.access_token) {
      setToken(data.access_token);
      window.localStorage.setItem('token', data.access_token);
    }
  };

  // Met à jour le header Authorization sur toutes les requêtes axios quand le token change
  useEffect(() => {
    if (token) {
      api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    } else {
      delete api.defaults.headers.common['Authorization'];
    }
  }, [token]);

  // Si le token est supprimé (logout), rafraîchir l'état
  useEffect(() => {
    const onStorage = () => {
      setToken(window.localStorage.getItem('token'));
    };
    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, []);

  useEffect(() => {
    // Gestion expiration session (écouteur global)
    const onSessionExpired = () => {
      setToken(null);
      window.localStorage.removeItem('token');
      window.sessionStorage.removeItem('token');
    };
    // Écouteur sur l'event session_expired
    import('./services/api').then(({ apiEvents }) => {
      apiEvents.on(onSessionExpired);
    });
    // Nettoyage
    return () => {
      import('./services/api').then(({ apiEvents }) => {
        apiEvents.off(onSessionExpired);
      });
    };
  }, []);


  return (
    <LocalSettingsProvider>
      <NotificationCenterProvider>
        <BrowserRouter>
          <AuthPingWatcher setToken={setToken} />
          <Routes>
            <Route path="/login" element={<Login onLogin={handleLogin} />} />
            <Route path="/admin" element={token ? <Admin /> : <Navigate to="/login" />} />
            <Route path="/desktop" element={token ? <DesktopPage /> : <Navigate to="/login" />} />
            <Route path="/database-config" element={token ? <DatabaseConfigPage /> : <Navigate to="/login" />} />
            <Route path="/app-group-applications" element={token ? <AppGroupApplicationsPage /> : <Navigate to="/login" />} />
            <Route path="/settings/backup" element={token ? <BackupSettingsPage /> : <Navigate to="/login" />} />
            <Route path="/settings/association" element={token ? <AssociationSettingsPage /> : <Navigate to="/login" />} />
            <Route path="/store-apps" element={token ? <StoreAppsPage /> : <Navigate to="/login" />} />
            <Route path="/putty" element={token ? <PuttyPage /> : <Navigate to="/login" />} />
            <Route path="/compose" element={<ComposeWindowApp />} />
            <Route path="/" element={<Navigate to="/desktop" />} />
          </Routes>
        </BrowserRouter>
      </NotificationCenterProvider>
    </LocalSettingsProvider>
  );
}

export default App;
